// Job type names as the client portal shows them (raf-frontend generateDocument.ts,
// createRafAssessment.ts). Keys are the stored jobType (raf-backend ServiceName).
// The client's wording is the source of truth: change it there first.
const JOB_TYPE_LABELS: Record<string, string> = {
  'raf-docx-fill': 'RAF1 Form (New)',
  'raf-pdf-acroform-fill': 'RAF1 Form (Old)',
  'raf-authorisation': 'Authorisation',
  'raf-affidavit': 'Affidavit',
  'raf-consultation-note': 'Consultation Note',
  'raf-checklist': 'MVA Checklist',
  'raf-merits-assessment': 'Merits Assessment',
  'raf-quantum-assessment': 'Quantum Assessment',
  'raf-extract-fields': 'Extract Fields',
};

export function jobTypeLabel(type: string | undefined): string {
  if (!type) return '';
  return JOB_TYPE_LABELS[type] ?? type.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function jobStatusLabel(status: string | undefined): string {
  if (!status) return '';
  const words = status.replace(/_/g, ' ').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
